import { createDeleteDeviceDetailedMutation, DeviceDetailed } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type DeleteDeviceDetailedModel = ConfirmModalModel<DeviceDetailed, number, null>;

export const createDeleteDeviceDetailedModel = (): DeleteDeviceDetailedModel => {
	const deleteDeviceDetailedMutation = createDeleteDeviceDetailedMutation();

	const model = createConfirmModalModel<DeviceDetailed, number, null>({
		modalData: declareModalData<DeviceDetailed>(),
		mapModalData: ({ id }) => id,
		mutation: deleteDeviceDetailedMutation,
		successMessageKey: 'delete-device.success',
	});

	return model;
};
